<template lang="pug">
v-sheet(height='70vh').d-flex.sdo-radius.sdo-shadow.overflow-auto.flex-no-wrap
  v-col(cols=12 lg=6).pa-0
    infinity-scroll-list(
      ref="infinityScroll"
      v-model="selected"
      :method="adapter"
      :filters="filters"
      :is-mobile="isMobile"
      :pagination="pagination"
      :queryField="queryField"
      :additionalQuery="additionalQuery"
      :showChips="showChips"
      :serializeData="serializeData"
      :queryData="query"
      :multiple="multiple"
      @unSelected="unSelected = $event"
    )
      template(#list-item="{item, index }")
        slot(name="list-item" v-bind="{ item, index }")
      template(#list-header="{ init, resetSearch }")
        slot(name="list-header" v-bind="{ init, unSelect, resetSearch }")
      template(
        #list-header-bottom=`{
          init, resetSearch,
          indeterminate, selectAll,
          unSelectAll, selectedCount, isAllSelected
        }`
      )
        slot(name="list-header-bottom"
         v-bind="{ init, unSelectAll, resetSearch, indeterminate, selectAll, isAllSelected }"
        )
  v-divider(vertical).ma-0
  v-col.pa-0(cols v-if="!isMobile")
    v-slide-y-transition(mode="out-in" )
      v-sheet.overflow-y-auto.scroll.grey.lighten-4(
        v-if="selected"
        flat
        :key="`${selected.id || selected.user_id}`" height="100%"
      )

        component(
          :item="selected"
          :is="detailsComponent.component"
          v-bind="detailsComponent.component_attrs"
          v-on="detailsComponent.component_listeners"
          :unSelected="unSelected"
        )

      v-sheet.fill-height.d-flex.align-center.grey.lighten-5.justify-center(
        v-else width="100%" key="123te"
      )
        slot(name="no-select")
          p.text-center.grey--text.text--darken-2.text-h5.my-3.px-4
            | Выберите элемент списка для детального отображения
  v-navigation-drawer(
    app
    v-else
    v-model="drawer"
    right
    temporary
    width="90%"
    height="100%"
  )
    v-card.sdo-card(
      v-if="selected"
      :key="`${selected.id || selected.user_id} ${detailsComponent.key}`"
      height='100%'
    ).pa-2.d-flex.flex-column
      component.overflow-auto(
        :is="detailsComponent.component"
        :detailsItem="selected"
        :item="selected"
        v-bind="detailsComponent.component_attrs"
        v-on="detailsComponent.component_listeners"
        :unSelected="unSelected"
      )
</template>

<script>
import InfinityScrollList from './components/InfinityScrollList.vue';

export default {
  components: {
    InfinityScrollList,
  },
  props: {
    detailsComponent: { type: Object, required: true },
    adapter: { type: Function, required: true },
    methods: { type: Object, default: null },
    pagination: { type: Boolean, default: false },
    filters: { type: Array, default: () => ([]) },
    additionalParams: { type: Object, default: () => ({}) },
    showChips: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    queryField: { type: Object, default: () => ({ label: 'Название', key: 'name' }) },
    serializeData: { type: Function, default: (data) => data },
    query: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      drawer: false,
      selected: null,
      unSelected: [],
      selectedCount: null,
      selectedItem: null,
      additionalQuery: {},
    };
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },

  },
  watch: {
    multiple(val) {
      if (val) this.$set(this, 'selected', this.selected ? [this.selected.id] : []);
      else this.selected = null;
    },
    drawer(val) {
      if (!val) this.selected = null;
    },
    async selected(val) {
      if (val) {
        this.drawer = true;
      }
      this.$emit('change');
    },
  },
  methods: {
    async selectById(id, searchTag = 'id') {
      this.unSelect();
      const search = `search[${searchTag}]`;
      const [item] = await this.$refs.infinityScroll.$refs.list.init(null, { [search]: id });
      this.selected = item;
      this.refreshList();
    },
    refreshList() {
      this.$refs.infinityScroll.$refs.list.init();
    },
    unSelect() {
      this.selected = null;
    },
    confirmDelete() {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите удаление',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.methods.delete(this.selected.id);
          this.selected = null;
          this.refreshList();
        },
      });
    },
  },
};
</script>
